module.exports = __webpack_public_path__ + "static/img/RAOK-L_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOK-L_1.png
// module id = wDFz
// module chunks = 0